import { Grid } from '@mui/material';
import * as React from 'react';
import { PassiveParameterTypeEnum } from '../../../../model/passive/enum/passiveParameterTypeEnum';
import { RadialIndicator } from '../../../documented/RadialIndicator';
import getRadialConfig from '../../../documented/RadialIndicator/radialConfig';

interface Props {
  minValue: number;
  maxValue: number;
  range: Array<number>;
  value: number;
  unit: string;
}

export const AverageCadencePanel: React.FC<Props> = ({
  minValue,
  maxValue,
  range,
  value,
  unit,
}) => {
  return (
    <>
      <Grid container>
        <Grid size={6}>
          <RadialIndicator
            {...getRadialConfig(PassiveParameterTypeEnum.AverageCadence)}
            size={200}
            value={value}
            unit={unit}
          />
        </Grid>
      </Grid>
    </>
  );
};
